import * as THREE from 'three';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'; // Import OBJLoader

export class VBOLoader {
    // Needs to be closer to the other geometrci objects, but for now:
    VertexAttributesSimple = {
        pntCount: 0,
        indCount: 0,
        indices: null,
        indicesLine: null,
        indicesOutline: null,
        position: {
            numberOfComponents: 3, // X and Y ordered pair coordinates
            data: null, // new Float32Array(pntCount * 3)
        },
    };

    constructor() {
        this.generalLoader = null;
    }

    // ////////////////////////////////////////////////////////////////////////////////////
    // TMP-Loader for VBO format, needs to be replaced by a lib cacl for general objects //
    // ////////////////////////////////////////////////////////////////////////////////////

    //
    // Simply splits the csv-string into an array
    //
    csvToArray(str, delimiter = '\n') {
        var arr = str.split(delimiter);
        return arr;
    }

    //
    // Initialize a VBO and fill it
    //
    loadVBO(arrayBuffer) {
        var dataArr = this.csvToArray(arrayBuffer, ' ');
        var cnt = 0;

        var vertAttr = Object.create(this.VertexAttributesSimple);

        vertAttr.pntCount = parseFloat(dataArr[cnt++]);
        vertAttr.indCount = parseFloat(dataArr[cnt++]);
        vertAttr.indices = []; //new Uint32Array(vertAttr.indCount);
        vertAttr.indicesLine = []; //new Uint32Array(vertAttr.indCount * 2);
        vertAttr.position.data = []; //new Float32Array(vertAttr.pntCount * 3);

        for (let y = 0; y < vertAttr.pntCount; y++) {
            var curID = y;
            vertAttr.position.data[3 * y + 0] = parseFloat(dataArr[cnt++]); // Careful, the z and y coordinates were switched here first. Check this!
            vertAttr.position.data[3 * y + 1] = parseFloat(dataArr[cnt++]);
            vertAttr.position.data[3 * y + 2] = parseFloat(dataArr[cnt++]);
        }
        var iCnt = 0;
        var tmp = 0;
        var indLst = [0, 0, 0];
        for (let y = 0; y < vertAttr.indCount; y++) {
            vertAttr.indices[y] = parseInt(dataArr[cnt++]);
            // Lines are erased here. Check if ThreeJS can create it for us, otherwise: Reactivate
        }

        // This one needs to change from: createGeomVBO() towards creating a threeJS mesh-geometry object that we can insert into the instanced rendering
        // this.VBOBuffer.dataAvailable = true;
        // if (!this.hasOutline)
        // 	this.createGeomVBO(gl);
        // this.loaded = true;

        // How to get a threeJS memory object here. Needs to be stored in the instance of that object Typed
        // ToDo: ...
        var meshGeom = new THREE.BufferGeometry();
        meshGeom.setIndex(vertAttr.indices);
        meshGeom.setAttribute('position', new THREE.Float32BufferAttribute(vertAttr.position.data, 3));

        return meshGeom;
    }

    // Copy from downloadOrCache(). No need to cache this data here (tiny)
    async downloadData(filename) {
        // const response = await fetch(fileObject.url);
        const response = await fetch(filename);
        if (!response.ok) {
            throw new Error('Network response was not ok: ' + response.statusText);
        }
        const arrayBuffer = await response.text();
        return arrayBuffer;
    }

    // Method to determine the file extension
    getFileExtension(filename) {
        return filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2);
    }

    // Method to load OBJ file
    async loadOBJ(filename) {
        const loader = new OBJLoader();
        return new Promise((resolve, reject) => {
            loader.load(
                filename,
                (group) => {
                    const mesh = group.children[0];

                    let geometry = mesh.geometry.clone();
                    if (!(geometry instanceof THREE.BufferGeometry)) {
                        geometry = new THREE.BufferGeometry().fromGeometry(geometry);
                    }

                    geometry.computeBoundingBox();
                    const bbox = geometry.boundingBox;

                    const oldVolume = (bbox.max.x - bbox.min.x) * (bbox.max.y - bbox.min.y) * (bbox.max.z - bbox.min.z);
                    const scaleFactor = Math.pow(1 / oldVolume, 1 / 3);

                    if (isFinite(scaleFactor)) {
                        geometry.scale(scaleFactor, scaleFactor, scaleFactor);
                    } else {
                        // reject(new Error("Invalid scale factor"));
                        // return;
                        geometry.scale(1.0, 1.0, 1.0);
                    }
                    const newBbox = geometry.boundingBox;
                    const newVolume = (newBbox.max.x - newBbox.min.x) * (newBbox.max.y - newBbox.min.y) * (newBbox.max.z - newBbox.min.z);

                    // console.log('Geometry ',filename, geometry,oldVolume,newVolume);

                    resolve(geometry);
                },
                null,
                (error) => {
                    reject(error);
                }
            );
        });
    }

    // Modified load method to handle both VBO and OBJ files
    async load(filename) {
        console.log(`  - - -  Trying to load general geometry from: ` + filename);
        const ext = this.getFileExtension(filename).toLowerCase();
        let geometry;

        if (ext === 'vbo') {
            const arrayBuffer = await this.downloadData(filename);
            if (!arrayBuffer) throw new Error('Invalid input: not an ArrayBuffer' + arrayBuffer);
            geometry = await this.loadVBO(arrayBuffer);
        } else if (ext === 'obj') {
            geometry = await this.loadOBJ(filename);
        } else {
            throw new Error('Unsupported file format', filename);
        }

        return geometry;
    }
}
